import socket from "services/sockets/socket";
import store from "services/store";
import { updatePlatform } from "actions";
import { createWindowAlert } from "actions/windowAlert";
import { getResource } from "selectors/resources";
import { Chatter } from "resourceModels";

/**
 * @param {Object} chatterAttributes
 */
function patchChatter(chatterAttributes) {
  const chatter = new Chatter(Chatter.deserialize(chatterAttributes));

  store.dispatch({
    type: "UPDATE_CHATTER",
    id: chatter.id,
    newResourceRecord: chatter
  });
}

/**
 */
export default function() {
  let isClientSubscribed = false;
  // Channel that's used for messages to all clients
  const broadcastChannel = socket.subscribe("announcements");

  /*
       When an 'alert' is sent over the announcements channel we will
       open a WindowAlert with the content of the alert data
     */
  broadcastChannel.bind("alert", (event) => {
    store.dispatch(createWindowAlert(event));
  });

  /**
   * @param {Client} client
   */
  function subscribeClientSocketEvents(client) {
    const clientChannel = socket.subscribe(`${client.id}`);
    isClientSubscribed = true;

    clientChannel.bind("chatter-status-changed", (msg) => {
      patchChatter(msg.chatter);
    });

    clientChannel.bind("zendesk-chat-oauth", (msg) => {
      if (msg.error) {
        window.console.error(msg);

        return;
      }

      store.dispatch(updatePlatform("zendesk_chat", {
        agentEmail: msg.agent_email,
        accessToken: msg.access_token
      }));
    });

    clientChannel.bind("zendesk-liveagent-oauth", (msg) => {
      if (msg.error) {
        window.console.error(msg);

        return;
      }

      store.dispatch(updatePlatform("zendesk_liveagent", {
        agentEmail: msg.agent_email,
        accessToken: msg.access_token
      }));
    });
  }

  store.subscribe(() => {
    if (!isClientSubscribed) {
      /** @type Client */
      const client = getResource(store.getState(), "client");

      if (client) {
        subscribeClientSocketEvents(client);
      }
    }
  });
}
